import request from '@/utils/request'


let CropSolutionApi = {
  /*分类管理*/
  cropSolutionList (data, errorback) {
    return request._postBody('/shop/crop/solution/index', data, errorback)
  },

  addCropSolution (data, errorback) {
    return request._postBody('/shop/crop/solution/add', data, errorback)
  },

  editCropSolution (data, errorback) {
    return request._postBody('/shop/crop/solution/edit', data, errorback)
  },

  deleteCropSolution (data, errorback) {
    return request._post('/shop/crop/solution/delete', data, errorback)
  },
  cropSolutionDetail (data, errorback) {
    return request._post('/shop/crop/solution/detail', data, errorback)
  },
  getCountResult (data, errorback) {
    return request._postBody('/shop/crop/solution/usage', data, errorback)
  },
  getCropPageSolution (data, errorback) {
    return request._postBody('/shop/crop/solution/page/usage', data, errorback)
  },

  getCropSolutionType (data, errorback) {
    return request._postBody('/shop/crop/solution/type', data, errorback)
  },

  addCropSolutionType (data, errorback) {
    return request._postBody('/shop/crop/solution/type/add', data, errorback)
  },

  editCropSolutionType (data, errorback) {
    return request._postBody('/shop/crop/solution/type/edit', data, errorback)
  },

  deleteCropSolutionType (data, errorback) {
    return request._post('/shop/crop/solution/type/delete', data, errorback)
  },
}

export default CropSolutionApi



// WEBPACK FOOTER //
// ./src/api/cropsolution.js